import { Delete } from "components/assets/Icons";
import styles from "./SchedulesTable.module.scss";
import { useState } from "react";
import Modal from "components/Modal";
import { ModalDelete } from "../Modals";
import { useEffect } from "react";

const SchedulesTable = ({
  schedulesData,
  setCurrentScreen,
  setEditingId,
  setIsRefresh,
  setMessage,
  setShowMessage,
}) => {
  const [currentRowId, setCurrentRowId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [scheduleId, setScheduleId] = useState({});
  const [scheduleName, setScheduleName] = useState("");

  useEffect(() => {}, [showModal]);
  let tableRows = (
    <tr>
      <td></td>
    </tr>
  );
  if (schedulesData.length > 0) {
    tableRows = schedulesData.map((schedule, idx) => (
      <tr
        key={schedule.id}
        onMouseEnter={() => {
          setCurrentRowId(schedule.id);
        }}
        onMouseLeave={() => {
          setCurrentRowId(null);
        }}
      >
        <td>
          <button
            className={`${styles.button} ${
              currentRowId === schedule.id
                ? styles.buttonShow
                : styles.buttonHidden
            }`}
            onClick={() => handleDeleteClick(schedule)}
          >
            <Delete />
          </button>
        </td>
        <td onClick={() => handleClick(idx)}>{schedule.name}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.mon}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.tue}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.wed}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.thu}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.fri}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.sat}</td>
        <td onClick={() => handleClick(idx)}>{schedule.shifts.sun}</td>
        <td onClick={() => handleClick(idx)}>{schedule.breakDuration}</td>
      </tr>
    ));
  }

  const handleClick = (id) => {
    setCurrentScreen("edit");
    setEditingId(id);
  };
  const handleDeleteClick = (schedule) => {
    setIsRefresh(true);
    setShowModal(true);
    setScheduleId(schedule.id);
    setScheduleName(schedule.name);
  };

  return (
    <>
      <div className={styles.wrapper}>
        <table className={styles.content}>
          <thead className={styles.header}>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
              <th>Breaks</th>
            </tr>
          </thead>
          <tbody className={styles.body}>{tableRows}</tbody>
        </table>
      </div>
      {showModal && (
        <Modal
          setShowModal={setShowModal}
          className={styles.modal}
          content={
            <ModalDelete
              data={scheduleId}
              setShowModal={setShowModal}
              scheduleName={scheduleName}
              setIsRefresh={setIsRefresh}
              setMessage={setMessage}
              setShowMessage={setShowMessage}
            />
          }
        />
      )}
    </>
  );
};

export default SchedulesTable;
